import React, { useState } from "react";
import { Collapse } from "@material-ui/core";
import { ButtonText } from "@loanbossinc/component-library";
import "./collapsibleFilterSectionStyles.css";

const Title = ({ title, isCollapsed, setIsCollapsed, numberOfFilters }) => (
  <div className="dl-scrn-coll-filter-sect-title-wrapper">
    <div className="dl-scrn-coll-filter-sect-title-text">{title}</div>
    <ButtonText
      className="dl-scrn-coll-filter-sect-title-hide-text"
      label={isCollapsed ? `Show ${numberOfFilters} filters` : "Hide"}
      onClick={() => setIsCollapsed(!isCollapsed)}
    />
  </div>
);

const CollapsibleFilterSection = ({ title = "", children, numberOfFilters = 0, isCollapsed = true, setIsCollapsed = () => { } }) => (
  <div className="dl-scrn-filter-panel-section-wrapper">
    <Title title={title} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} numberOfFilters={numberOfFilters} />
    <Collapse in={!isCollapsed}>
      <div className="dl-scrn-filter-panel-section-filters-section-wrapper">{children}</div>
    </Collapse>
  </div>
);

export default CollapsibleFilterSection;
